@file:UseSerializers(UuidSerializer::class)
@file:Suppress("NonAsciiCharacters")

package it.neckar.lizergy.model.configuration.moduleLayout.roof

import kotlin.uuid.Uuid
import it.neckar.lizergy.lifeCycle.LizergyHasLifeCycle
import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.uuid.HasUuid
import it.neckar.uuid.UuidSerializer
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Serializable
data class MetalRoofTile(
  val id: MetalRoofTileId,

  /**
   * The name / label of the roof tile
   */
  val description: String,

  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,

  ) : HasUuid, LizergyHasLifeCycle {

  override val uuid: Uuid
    get() = id.uuid

  /**
   * An id for a roof
   */
  @Serializable
  data class MetalRoofTileId(val uuid: Uuid) {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): MetalRoofTileId {
        return MetalRoofTileId(randomUuid4())
      }
    }
  }
}
